module.exports = __webpack_public_path__ + "img/38-4.6482f5bf.jpg";